var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgVideoStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 39.012,
    viewBox: "0 0 47 39.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11423",
    "data-name": "Group 11423",
    transform: "translate(-734.611 -8541.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42731",
    "data-name": "Path 42731",
    d: "M20,0q6.843,0,13.686,0A6.008,6.008,0,0,1,40,6.356q0,7.719,0,15.439a6.041,6.041,0,0,1-6.179,6.213c-.847.007-1.858-.233-2.495.146-.608.362-.827,1.382-1.217,2.112-.1.188-.2.38-.3.565A1.982,1.982,0,0,1,26.8,31.6c-1.625-1.059-3.216-2.171-4.847-3.22a2.307,2.307,0,0,0-1.172-.357C15.887,28,10.994,28.017,6.1,28A6.019,6.019,0,0,1,.075,22.918,6.125,6.125,0,0,1,0,21.856Q0,13.995,0,6.133A5.986,5.986,0,0,1,6.106.007C10.739-.008,15.372,0,20,0M18.122,15.158a2.6,2.6,0,0,1-.293-.175c-.79-.783-1.574-1.571-2.368-2.35a2,2,0,1,0-2.814,2.832q1.873,1.893,3.763,3.768a2.018,2.018,0,0,0,3.165.02q3.845-3.836,7.673-7.689a2.056,2.056,0,0,0,.2-2.974,2.021,2.021,0,0,0-3.015.148q-1.565,1.547-3.111,3.114c-1.074,1.094-2.132,2.2-3.2,3.306",
    transform: "translate(738.111 8544.708)",
    fill: "#fff",
    stroke: "#7833ba",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42724",
    "data-name": "Path 42724",
    d: "M20,0q6.843,0,13.686,0A6.008,6.008,0,0,1,40,6.356q0,7.719,0,15.439a6.041,6.041,0,0,1-6.179,6.213c-.847.007-1.858-.233-2.495.146-.608.362-.827,1.382-1.217,2.112-.1.188-.2.38-.3.565A1.982,1.982,0,0,1,26.8,31.6c-1.625-1.059-3.216-2.171-4.847-3.22a2.307,2.307,0,0,0-1.172-.357C15.887,28,10.994,28.017,6.1,28A6.019,6.019,0,0,1,.075,22.918,6.125,6.125,0,0,1,0,21.856Q0,13.995,0,6.133A5.986,5.986,0,0,1,6.106.007C10.739-.008,15.372,0,20,0M18.122,15.158a2.6,2.6,0,0,1-.293-.175c-.79-.783-1.574-1.571-2.368-2.35a2,2,0,1,0-2.814,2.832q1.873,1.893,3.763,3.768a2.018,2.018,0,0,0,3.165.02q3.845-3.836,7.673-7.689a2.056,2.056,0,0,0,.2-2.974,2.021,2.021,0,0,0-3.015.148q-1.565,1.547-3.111,3.114c-1.074,1.094-2.132,2.2-3.2,3.306",
    transform: "translate(738.111 8544.708)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgVideoStep3);
export default __webpack_public_path__ + "static/media/img_video_step_3.b7a8ce139c804b8604b51fc47150add9.svg";
export { ForwardRef as ReactComponent };